<template>
    <div>
      <h3 class="h4 mb-3">{{ ticket.event_pos_item.name }}</h3>
      <p class="text-muted mb-4">{{ ticket.event_pos_item.description }}</p>
  
      <div class="card mb-4">
        <div class="card-body">
          <small class="text-muted">Transaction ID</small>
          <p class="h5">{{ ticket.id }}</p>
        </div>
      </div>
  
      <div class="row">
        <div class="col-6">
          <div class="card">
            <div class="card-body">
              <small class="text-muted">Amount</small>
              <p class="h5">${{ ticket.amount }}</p>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="card">
            <div class="card-body">
              <small class="text-muted">Date</small>
              <p class="h5">{{ new Date(ticket.created_at).toLocaleDateString() }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TicketInfo',
    props: {
      ticket: {
        type: Object,
        required: true
      }
    }
  }
  </script>